import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const skeletonTheme: ThemeOptions['components'] = {
  MuiSkeleton: {
    defaultProps: {
      variant: 'rectangular',
      animation: 'wave',
    },
    styleOverrides: {
      root: {
        background: tokens.theme.bg.loading.skeleton,
        borderRadius: tokens.theme.radius.sm,

        '&.MuiSkeleton-circular': {
          borderRadius: '100%',
        },
        '.DSuiSkeletonTable-x-large &': {
          height: '48px',
        },
        '.DSuiSkeletonTable-large &': {
          height: '40px',
        },
        '.DSuiSkeletonTable-medium &': {
          height: '32px',
        },
        '.DSuiSkeletonTable-small &': {
          height: '28px',
        },
      },
    },
  },
};
